/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { I18n } from "@aws-amplify/core";
import AmplifyForgotPassword from "aws-amplify-react/lib/Auth/ForgotPassword";
import { AuthShell, withInlineAuthError } from "./AuthFormShared";
import { ForgotPasswordFormView } from "./AuthFormViews";

const ForgotPasswordBase: any = withInlineAuthError(AmplifyForgotPassword);

export class ForgotPassword extends ForgotPasswordBase {
    showComponent() {
        const { hide, authData = {} } = this.props;
        if (hide && hide.includes(ForgotPassword)) {
            return null;
        }

        const deliveryMode = Boolean(this.state.delivery || authData.username);
        const usernameLabel = I18n.get(this.getUsernameLabel());

        return (
            <AuthShell title={I18n.get("Reset your password")}>
                <ForgotPasswordFormView
                    error={this.state.authError}
                    mode={deliveryMode ? "confirm" : "request"}
                    onBackToSignIn={() => this.changeState("signIn")}
                    onFieldChange={this.handleInputChange}
                    onResendCode={this.send}
                    onSubmit={event => {
                        event.preventDefault();
                        if (deliveryMode) {
                            this.submit();
                        } else {
                            this.send();
                        }
                    }}
                    usernameLabel={usernameLabel}
                />
            </AuthShell>
        );
    }
}

export default ForgotPassword;
